import React, { Component, Suspense } from "react"

/* Socket IO */
import { io } from "socket.io-client"

/* Constants */
import { env, utils, tempstake } from "./constants"
import { LOADING, ERROR, WAITING, CHOICE } from "./constants/status"

/* UUID */
import { v4 as uuidv4 } from "uuid"

/* Widgets */
import { Preloader } from "./widgets"

/* Components */
import { GamePayout } from "./components"

/* Rules */
import { list } from "./constants/rules"

/* Widgets */
import { Chips, Rates, Result, Timer, History, Roads } from "./widgets"

/* Components */
import { Background, Error } from "@cuba-go/poker-ui"

/* POKER UI */
const GameControl = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.GameControl })))
const Balance = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.Balance })))
const Internet = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.Internet })))
const GameInfo = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.GameInfo })))
const Notification = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.Notification })))
const FloatingMessages = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.FloatingMessages })))

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""





/* Entry Point */
class App extends Component {

    constructor() {
        super()

        this.state = {

            /* General */
            status: LOADING,
            balance: null,

            /* Rates */
            stake: { ...tempstake },
            last: null,
            list: [],
            selected: 1,
            lastWin: 0,

            /* Game */
            result: null,
            playerCards: [],
            playerScore: 0,
            bankerCards: [],
            bankerScore: 0,

            /* Road Results */
            results: [],

            /* Dealer */
            dealerInfo: null,
            gameInfo: null,

            /* Transactions */
            transactions: [],
            operations: [],

            /* Game Session */
            closed: false,
            newDevice: false,
            isDisconnected: false,
            isPaused: false,
        }

        /* Start connection */
        this.socket = io(env.endpoint, { auth: { token: `${token}`, type: "player" } })
    }

    componentDidMount = () => {
        this.game()
    }

    /* Game Socket Events */
    game = () => {

        /* On error */
        this.socket.on("connect_error", () => {

            this.clear()

            const timer = setTimeout(() => {
                this.setState({ status: ERROR })
                clearTimeout(timer)
            }, 1000)
        })

        /* On New Device */
        this.socket.on("newDeviceConnection", () => {
            this.setState({ newDevice: true })
            this.socket.disconnect()
            this.clear()
        })

        /* On Diconnect */
        this.socket.on("disconnect", () => {
            this.setState({ isDisconnected: true })
            this.clear()
        })

        /* On connect */
        this.socket.on("connect", () => {
            const timer = setTimeout(() => {
                this.setState({ status: null })
                clearTimeout(timer)
                this.resetTimer()
            }, 2000)
        })

        /* On Balance */
        this.socket.on("balance", balance => {
            this.setState({ balance })
        })

        /* On Diconnect */
        this.socket.on("gameInfo", gameInfo => {
            this.setState({ gameInfo })
        })


        /* On Balance */
        this.socket.on("card", ({ card, type, score }) => {

            /* Fields */
            const { bankerCards, playerCards, bankerScore, playerScore } = this.state
            let _bankerScore = bankerScore
            let _playerScore = playerScore

            /* Banker */
            if (type === "banker") {
                const index = bankerCards.findIndex(e => e.uid === card.uid)
                if (index === -1) {
                    bankerCards.push(card)
                    _bankerScore = score
                }
            }

            /* Player */
            if (type === "player") {
                const index = playerCards.findIndex(e => e.uid === card.uid)
                if (index === -1) {
                    playerCards.push(card)
                    _playerScore = score
                }
            }

            this.setState({ bankerCards, playerCards, bankerScore: _bankerScore, playerScore: _playerScore })
        })


        /* On Status */
        this.socket.on("status", status => {

            /* Fields */
            const { status: _status } = this.state

            /* Check Status */
            if (_status !== status) {

                /* Set Status */
                this.setState({ status }, () => {

                    /* On Choice */
                    if (status === CHOICE) {
                        this.clear()
                    }

                })

            }

        })

        /* On Timer */
        this.socket.on("timer", timer => {
            if (this._timing) {
                this._timing.start(timer)
            }
        })

        /* On Balance */
        this.socket.on("result", data => {

            /* Fields */
            const { results } = this.state

            /* Save Result */
            this.setState({ result: data })

            /* Set Last Win */
            if (data && data.total && parseFloat(data.total) > 0) {
                this.setState({ lastWin: parseFloat(data.total) })
            }

            /* Check Win */
            if (data && data.win) {

                /* Save Result | isPlayerPair / isBankerPair belong to the round, not to the payout */
                const next = [...results, {
                    win: data.win,
                    playerPair: data.isPlayerPair === true,
                    bankerPair: data.isBankerPair === true,
                }]

                this.setState({ results: next }, () => {
                    this.scrollRoads()
                })
            }
            else {
                this.scrollRoads()
            }

        })

        /* On Road Results */
        this.socket.on("results", results => {
            this.setState({ results: results || [] }, () => {
                this.scrollRoads()
            })
        })



        /* On Reconnection */
        this.socket.on("reconnection", data => {

            if (data.reason && data.reason === "transaction") {
                this.notify("transaction", "show")
            }

            if (data.isPaused) {
                this.notify("pause", "show")
            }

            /* Close Timing */
            const timer = setTimeout(() => {
                this.notify("transaction", "close")
                clearTimeout(timer)
            }, 3000)

            /* Set Balance */
            if (data.balance) {
                this.setState({ balance: data.balance })
            }

            this.setState(
                {

                    /* General */
                    status: data.status,

                    /* Rates */
                    stake: data.stake || { ...tempstake },
                    last: data.stake || null,
                    list: data.stake ? utils.reconnectionChipsList(data.stake) : [],
                    lastWin: data.result && data.result.total && parseFloat(data.result.total) > 0 ? parseFloat(data.result.total) : 0,

                    /* Game */
                    result: data.result || null,
                    playerCards: data.playerCards || [],
                    playerScore: data.playerScore || 0,
                    bankerCards: data.bankerCards || [],
                    bankerScore: data.bankerScore || 0,
                    results: data.results || [],

                    /* Dealer */
                    dealerInfo: data.dealerInfo || null,
                    gameInfo: data.gameInfo || null,

                    transactions: data.transactions || [],
                    isPaused: data.isPaused,

                },
                () => {

                    /* Start Timing */
                    if (data.status === CHOICE && this._timing) {
                        this._timing.start(data.timer)
                    }

                    this.scrollRoads()

                })

        })



        /* Get transactions */
        this.socket.on("transaction", data => {
            /* Check Transaction */
            if (data && data.id) {

                /* Fields */
                const { transactions, operations } = this.state

                const _transactions = [...transactions]
                const _operations = [...operations]

                _transactions.push(data)
                _operations.push(data)

                this.setState({ transactions: _transactions, operations: _operations })

                const timer = setTimeout(() => {
                    this.setState({ operations: [...this.state.operations].filter(item => item.id !== data.id) })
                    clearTimeout(timer)
                }, 3500)

            }
        })

        /* On Edit Transaction */
        this.socket.on("editTransaction", data => {

            /* Fields */
            const { transactions } = this.state
            let _transactions = [...transactions]

            /* Get Index */
            const index = _transactions.findIndex(e => e.number === data.number)

            /* Check Index */
            if (index > -1) {
                _transactions[index].status = data.status
                this.setState({ transactions: _transactions })
            }

        })

        /* Get pause command from dealer monitor */
        this.socket.on("pause", () => {
            this.setState({ isPaused: true })
            this.notify("pause", "show")
        })

        /* Continue Event */
        this.socket.on("continue", () => {
            this.setState({ isPaused: false })
            this.notify("pause", "close")
        })

        /* Force End Event | The game is ended by the administrator */
        this.socket.on("forceEnd", () => {

            /* Close Pause Notification */
            this.notify("pause", "close")

            /* Clear Game */
            this.setState({ isPaused: false, status: WAITING }, () => this.clear())

            /* Notify Player */
            this.notify("forceEnd", "show")

            /* Close Notification */
            const timer = setTimeout(() => {
                this.notify("forceEnd", "close")
                clearTimeout(timer)
            }, 7000)

        })

        /* Refund Event | The administrator returned the bet or paid the amount */
        this.socket.on("refund", data => {

            /* Fields */
            const total = data && typeof data === "object" ? data.total : data
            const type = data && typeof data === "object" && data.type ? data.type : "refund"

            this.notify("refund", "refund", { type, total })
        })

    }

    /* Scroll Roads to the End | Must run after the results are rendered */
    scrollRoads = () => {

        if (this._beadPlate_) {
            this._beadPlate_.scrollAll()
        }

        if (this._roads_) {
            this._roads_.scrollAll()
        }

    }

    /* Set Stake */
    setStake = stake => {
        this.setState({ stake, last: stake, lastWin: 0 })
        this.socket.emit("stake", stake)
    }

    /* Clear Action */
    clear = () => {
        this.setState({

            /* Rates */
            stake: { ...tempstake },
            list: [],

            /* Game */
            result: null,
            playerCards: [],
            playerScore: 0,
            bankerCards: [],
            bankerScore: 0,

            /* Transactions */
            transactions: [],
            operations: [],

        })
    }

    /* Reser top timing */
    resetTimer = () => {
        if (this._inaction) {
            this._inaction.reset()
        }
    }

    /* Check internet speed */
    checkInternetSpeed = (speed) => {
        if (parseInt(speed) < 5) {
            this.notify("internet", "show")
        }
        else {
            this.notify("internet", "close")
        }
    }


    /* Show and close notifications */
    notify = (type, action, data = null) => {

        const notifyData = { type, action, data }

        if (this._notify) {
            this.notifyAction(notifyData)
        }
        else {
            setTimeout(() => {
                if (this._notify) {
                    this.notifyAction(notifyData)
                }
            }, 2000)
        }

    }


    /* Do notify actions after notify component check */
    notifyAction = (notifyData) => {

        const { type, action, data = null } = notifyData
        if (action === "show") {
            this._notify.show(type)
        }
        else if (action === "close") {
            this._notify.close(type)
        }
        else if (action === "refund") {
            if (data.total) {
                const title = data.type === "refund" ? "Возврат средств" : "Пополнение суммы"
                const uid = uuidv4()
                this._notify.refund({ title, total: data.total, uid })
            }
        }

    }


    /* Send Message */
    sendMessage = message => {
        this.socket.emit("messageFromPlayer", message.message)
        if (this._floatingMessages) {
            this._floatingMessages.sendMessage(message)
        }
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, stake, last, selected, list, balance, bankerCards, playerCards, result, bankerScore, playerScore } = this.state
        const { chips, max, currency } = utils.getData(token)

        return (
            <div className={`game status-${status}`}>

                {status === CHOICE &&
                    <Chips
                        chips={chips}
                        stake={stake}
                        setStake={data => this.setStake(data)}
                        last={last}
                        selected={selected}
                        setSelected={selected => this.setState({ selected })}
                        list={list}
                        setList={list => this.setState({ list })}
                        balance={balance}
                        notify={this.notify}
                        currency={currency}
                        max={max}
                    />
                }

                <Rates
                    status={status}
                    chips={chips}
                    stake={stake}
                    setStake={data => this.setStake(data)}
                    selected={selected}
                    list={list}
                    setList={list => this.setState({ list })}
                    notify={this.notify}
                    balance={balance}
                    max={max}
                    result={result}
                    bankerCards={bankerCards}
                    playerCards={playerCards}
                    bankerScore={bankerScore}
                    playerScore={playerScore}
                />

            </div>
        )
    }


    /* Draw Result */
    _result = () => {

        /* Fields */
        const { status, result } = this.state
        const { currency } = utils.getData(token)

        return <Result status={status} result={result} currency={currency} />
    }

    /* Draw Timer */
    _timer = () => {

        /* Fields */
        const { status } = this.state

        return <Timer ref={ref => this._timing = ref} active={status === CHOICE} />
    }


    /* Draw Payout */
    _payout = () => {

        /* Fields */
        const { max, min, currency } = utils.getData(token)

        return <GamePayout currency={currency} max={max} min={min} />
    }

    /* Roads */
    _roads = () => {

        /* Fields */
        const { results, status } = this.state

        return (
            <div className={`road-results road-${status}`}>
                <Roads ref={ref => this._beadPlate_ = ref} type="bead-plate" results={results} />
                <Roads ref={ref => this._roads_ = ref} results={results} />
            </div>
        )
    }

    /* Backround Props */
    _backgroundProps = () => {

        /* Fields */
        const { status, dealerInfo, transactions, gameInfo } = this.state
        const { currency, identifier, backColor, gameImg } = utils.getData(token)

        return {
            token,
            gamePlace: env.gamePlace,
            currency,
            status,
            dealer: dealerInfo,
            sendMessage: message => this.sendMessage(message),
            sendSupportMessage: message => this.sendSupportMessage(message),
            info: gameInfo,
            transactions,
            gamePayout: this._payout(),
            identifier,
            rules: list,
            videoBackImg: gameImg,
            textileColor: backColor,
            //histories: []
            historyComponent: History
        }
    }

    render = () => {

        /* Fields */
        const { status, stake, newDevice, closed, isDisconnected, gameInfo, operations, dealerInfo, balance, lastWin } = this.state
        const { max, min, currency, gameImg } = utils.getData(token)
        const total = utils.getTotal(stake)

        /* Error */
        if (status === ERROR || newDevice || closed || isDisconnected) {
            return <Error newDevice={newDevice} closed={closed} isDisconnected={isDisconnected} />
        }

        /* Preloader */
        if (status === LOADING) {
            return <Preloader url={gameImg} />
        }

        return (
            <Background ref={this._background} {...this._backgroundProps()}>

                {this._timer()}
                {this._content()}
                {this._result()}
                {this._roads()}

                <Suspense fallback={<div />}>
                    <GameInfo currency={currency} info={gameInfo} operations={operations} />
                    <GameControl title="PUNTO BANCO" max={max} min={min} currency={currency} info={gameInfo} data={dealerInfo} gamePayout={this._payout()} onQuitGame={() => this.quitGame()} />
                    <Balance balance={balance} total={total} lastWin={lastWin} currency={currency} />
                    <FloatingMessages ref={ref => this._floatingMessages = ref} />
                    <Notification nextGame={status === WAITING} ref={ref => this._notify = ref} currency={currency} max={max} />
                    <Internet url={env.internetSpeedImgLink} setInternetSpeed={data => this.checkInternetSpeed(data)} />
                </Suspense>

            </Background>
        )
    }
}

export default App